import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { BreederGetLittersQuery, BreederGetLittersQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';
import { useLitterOrderBuilder } from '../../LitterListPageController/api/useLitterOrderBuilder';
import { useLitterWhereBuilder } from '../../LitterListPageController/api/useLitterWhereBuilder';

export const BREEDER_GET_LITTERS = graphql(`
  query BreederGetLitters(
    $take: Int
    $skip: Int
    $where: LitterWhereInput
    $orderBy: [LitterOrderByWithRelationAndSearchRelevanceInput!]
    $litterCardInfoImgsTake: Int!
    $litterCardInfoTranslationsWhere: LitterTranslationWhereInput!
    $litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput!
  ) {
    findManyLitter(skip: $skip, take: $take, where: $where, orderBy: $orderBy) {
      ...LitterCardInfo
    }
  }
`);

export const useGetLitters = (breederId?: number, breedIds?: number[]) => {
  const { language } = useRouter();
  const { litterWhereBuilder } = useLitterWhereBuilder();
  const { litterOrderBuilder } = useLitterOrderBuilder();

  const variables = useMemo((): BreederGetLittersQueryVariables => {
    return {
      take: 16,
      where: {
        AND: [
          { ...litterWhereBuilder() },
          { breederId: { not: { equals: breederId } } },
          { dogBreedId: { in: breedIds } },
        ],
      },
      orderBy: litterOrderBuilder(),
      litterCardInfoImgsTake: 1,
      litterCardInfoTranslationsWhere: { language: { equals: language } },
      litterCardInfoBreedTranslationsWhere: { language: { equals: language } },
    };
  }, [breedIds, breederId, language, litterOrderBuilder, litterWhereBuilder]);

  const { data, error, loading } = useQuery<
    BreederGetLittersQuery,
    BreederGetLittersQueryVariables
  >(BREEDER_GET_LITTERS, {
    variables,
    skip: !breedIds?.length || breederId == null,
    ssr: false,
  });

  return {
    litters: data?.findManyLitter ?? [],
    littersError: error,
    littersLoading: loading,
    littersVariables: variables,
  };
};
